/* =============================================================
 * import
 * ========================================================== */
import {eventObserver} from "./eventObserver";
import {intervalObserver} from "./intervalObserver";
import {scrollToSmooth} from '../modules/scrollToSmooth';
import {ScrollTrigger} from "gsap/ScrollTrigger";


/* =============================================================
 * function
 * ========================================================== */

// ページ個別のメタ情報を書き換える処理
export const replaceHeadTags = target => {
  const head = document.head;
  const targetHead = target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
  const newPageHead = document.createElement('head');
  newPageHead.innerHTML = targetHead;
  const removeHeadTags = [
    'meta[name=\'keywords\']',
    'meta[name=\'description\']',
    'meta[property^=\'fb\']',
    'meta[property^=\'og\']',
    'meta[name^=\'twitter\']',
    'meta[name=\'robots\']',
    'meta[itemprop]',
    'link[itemprop]',
    'link[rel=\'prev\']',
    'link[rel=\'next\']',
    'link[rel=\'canonical\']',
  ].join(',');
  const headTags = [...head.querySelectorAll(removeHeadTags)];
  headTags.forEach(item => {
    head.removeChild(item);
  });
  const newHeadTags = [...newPageHead.querySelectorAll(removeHeadTags)];
  newHeadTags.forEach(item => {
    head.appendChild(item);
  });
};


// GoogleAnalyticsにアクセス情報を送る処理
export const gaSend = (gaTagType, domain, domainProd) => {
  if (gaTagType === 'ga4' && domain === domainProd) {  // GA4直接管理＆本番環境の場合のみ実行
    gtag('event', 'page_view', { // eslint-disable-line no-undef
      'page_title': document.title,
      'page_location': location.href,
      'page_path': location.pathname,
    });
  }
};


export const customPreventCheck = (elm, event, href) => {

  // event: click, hoverなどが入るので、管理に注意すること。
  const currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname; // ページの現在のURLを取得（ハッシュを除外）
  const currentFullURL = window.location.href.split('#')[0]; // ハッシュを除外
  const linkUrl = new URL(href, window.location.origin);  // リンクのhref属性からページのURL部分を抽出


  // 別タブリンクの場合、Barba遷移を無効化
  if (elm.hasAttribute('target')) {
    if (elm.getAttribute('target') === '_blank') {
      return true;
    }
  }


  // 特定のクラスに対するBarba遷移を無効化
  const ignoreClasses = ['no-barba', 'js-gallery-link'];
  for (let i = 0; i < ignoreClasses.length; i++) {
    if (elm.classList.contains(ignoreClasses[i])) {
      return true;
    }
  }


  // 特定のURLに対するBarba遷移を無効化
  if (
    href.includes('/attachment/') ||
    href.includes('/wp-admin/') ||
    href.includes('action=logout')
  ) {
    return true;
  }


  // 特定の拡張子が該当する場合、target='_blank'に変更し、Barba遷移を無効化
  if (/\.(xlsx?|docx?|pptx?|pdf|jpe?g|png|gif|svg)/.test(href.toLowerCase())) {
    elm.setAttribute('target', '_blank');
    elm.setAttribute('rel', 'noopener');
    return true;
  }


  // アンカー（#ハッシュ）か、data-scroll-hashを持つ場合の設定
  // #はブラウザ依存の遷移イベントと競合し、安定しないので、独自のdata-scroll-hashを極力使うこと
  const dataHash = elm.dataset.scrollHash;

  if (linkUrl.href === currentUrl || linkUrl.href.split('#')[0] === currentUrl) {

    // 現在のページにsパラメータ（WPの検索結果画面）が付いている場合遷移させる
    if (currentFullURL.includes('?s=')) {
      return false;
    }

    // 同じページへの遷移を防ぐ
    event.preventDefault();   // 通常の遷移イベントをキャンセル
    event.stopPropagation();  // barbajsの遷移イベントをキャンセル


    // クリックイベントの場合
    if (event.type === 'click') {
      // ハッシュが含まれる場合にのみ実行
      if (dataHash !== undefined && dataHash !== null && dataHash !== '') {
        scrollToSmooth(dataHash, .4, event); // スムーズスクロール関数を呼び出し
      } else {
        scrollToSmooth(linkUrl.hash, .4, event); // スムーズスクロール関数を呼び出し
      }
    }
    return true;
  }

};


/* ********************************************
 * resetAnyFunc
 * ページ読み込み時の処理リセット用関数
 * ****************************************** */
export function resetAnyFunc() {
  eventObserver.clearEvents();
  intervalObserver.clearIntervals();
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
}
